import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { DarkSkeleton } from '@eika/skeleton';

const AccountBSUSkeleton: React.FC = () => {
    return (
        <div className="sgw-account-details skeleton account-with-progress-bar">
            <section className="sgw-account-details__meta account-view__balance-container use-tabs">
                <div className="sgw-tabs">
                    <div className="sgw-tabs__button-wrapper">
                        <DarkSkeleton width={200} height={58} />
                    </div>
                    <dl className="sgw-account-details__wrapper">
                        <dd className="account-details__amount">
                            <span className="amount">
                                <Skeleton width={220} height={42} />
                            </span>
                            <div className="account-balance__progress-bar">
                                <Skeleton width="90%" height={8} />
                            </div>
                            <Skeleton width={200} height={16} />
                        </dd>
                        <div className="sgw-tab account-view__bsu-details-container is-selected">
                            <dt className="bsu-details-term">
                                <Skeleton width={80} height={16} />
                            </dt>
                            <dd className="bsu-details-description">
                                <Skeleton width={40} height={16} />
                            </dd>
                            <dt className="bsu-details-term">
                                <Skeleton width={90} height={16} />
                            </dt>
                            <dd className="bsu-details-description">
                                <Skeleton width={60} height={16} />
                            </dd>
                            <dt className="bsu-details-term">
                                <Skeleton width={70} height={16} />
                            </dt>
                            <dd className="bsu-details-description">
                                <Skeleton width={80} height={16} />
                            </dd>
                        </div>
                    </dl>
                    <div className="background-wrapper">
                        <div className="background" />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AccountBSUSkeleton;
